// 237: Premier League, 314: Bundesliga, 538: La Liga, 392: Serie A
export const LEAGUE_IDS = [237, 314, 538, 392];
export const LEAGUE_ID_KEY1 = [237, 314];
export const MAX_TOP_SCORERS = 10;
export const MAX_FORM_RESULTS = 5;

export const HALF_HOUR = 1000 * 60 * 30;
export const WEEK = 1000 * 60 * 60 * 24 * 7 * 2;
export const MONTH = 1000 * 60 * 60 * 24 * 30;
export const YEAR = 1000 * 60 * 60 * 24 * 365;
